export const it = {
    // Italian translations:
    required: '* Campo obbligatorio',
    validation: {
        required: controlName => `Inserire ${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()}`,
        minmaxNotLessThen: (controlName, min) => `${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()} non può essere inferiore a ${min}`,
        minmaxNotGreaterThen: (controlName, max) => `${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()} non può essere superiore a ${max}`,
    },
    switch: {
        yes: 'Sì',
        no: 'No',
    },
    dateRange: {
        arrival: 'Arrivo',
        departure: 'Partenza',
    },
    travelData: {
        title: 'Inserisci i dati della tua vacanza e ricevi offerte personalizzate via e-mail, direttamente dalle strutture.',
        range: 'data di arrivo e partenza',
        hasPets: 'Animali',
        petsMessage: 'descrizione animali',
        petsMessagePlaceholder: "es. 1 cane di grossa taglia (ca. 10 kg), 2 gatti…",
        boards: 'Trattamento',
        rooms: {
            validation: {
                roomsMissing: 'Inserire almeno 1 camera',
                adultsMissing: 'Inserire il numero degli adulti',
                roomsWithoutAdults: 'Inserire almeno 1 adulto per ogni camera',
                childAgeMissing: 'Inserire età dei bambini',
            },
            adults: 'Adulti',
            children: 'Bambini',
            rooms: 'Camere',
            age: 'Età',
            room: 'Camera/appartamento',
            roomInfo: 'Informazioni che si riferiscono a una camera, un appartamento, una piazzola ecc.',
            removeRoom: 'Cancella camera/appartamento',
            addRoom: 'Inserisci camera/appartamento',
            childrenAges: 'Età dei bambini',
            years: age => `${age} ${age == 1 ? 'anno' : 'anni'}`,
            done: 'Fatto',
        },
        submit: 'Continua',
    },
    filter: {
        title: 'Scegli la tipologia di struttura e la regione che preferisci e scopri quali strutture fanno al caso tuo!',
        accotypesValidatorText: controlName => `Scegliere ${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()}`,
        areaValidatorText: controlName => `Scegliere ${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()}`,
        maxCountValidatorText: (controlName, max) => `È possibile selezionare un massimo di ${max} alloggi.\nUtilizzare altri filtri.`,
        accotypesAndBoards: 'Tipo di alloggio & trattamento',
        boards: 'Trattamento',
        accotypes: 'Tipo di alloggio',
        areas: 'Regioni & località',
        resorts: 'Località',
        regions: 'Regioni',
        selectAllRegions: 'Scegli tutte le regioni dell’Alto Adige',
        searchAreas: 'Cerca regioni e località…',
        themesAmeneties: 'Attrezzatura / Tipo di vacanza',
        ameneties: 'Attrezzatura',
        themes: 'Tipo di vacanza',
        overlay: {
            accosText: count => `<b>${count}</b> ${count == 1 ? "alloggio" : "alloggi"} scelto/i`,
            done: 'Fatto',
        },
        back: 'Indietro',
        submitContinueWith: 'Continua con',
        submitAccosText: count => `${count} ${count == 1 ? "alloggio" : "alloggi"}`,
    },
    accos: {
        title: 'Panoramica degli alloggi',
        subtitle: (selected, count) => `Invia una richiesta a ${selected} ${selected == 1 ? "struttura" : "strutture"} o scegli una struttura specifica`,
        back: 'Indietro',
        submitContinueWith: 'Continua con',
        submitAccosText: count => `${count} ${count == 1 ? "alloggio" : "alloggi"}`,
    },
    personalData: {
        accosCount: count => `<b>${count}</b> ${count == 1 ? "alloggio" : "alloggi"}`,
        adults: count => `<b>${count}</b> ${count == 1 ? 'adulto' : 'adulti'}`,
        children: count => `<b>${count}</b> ${count == 1 ? 'bambino' : 'bambini'}`,
        rooms: count => `<b>${count}</b> ${count == 1 ? 'camera' : 'camere'}`,
        pets: 'Animale/i domestico/i',
        accotypes: count => `${count == 1 ? 'Tipo di alloggio:' : 'Tipi di alloggio:'}`,
        areas: count => `${count == 1 ? 'Regione/località:' : 'Regioni/località:'}`,

        title: 'Inserisci i tuoi dati, per ricevere offerte personalizzate direttamente dalle strutture!',
        email: 'E-mail',
        salutation: 'Titolo',
        salutationOptions: {
            herr: 'Signor',
            frau: 'Signora',
            familie: 'Famiglia',
            firma: 'Ditta',
        },
        firstname: 'Nome',
        lastname: 'Cognome',
        phone: 'Telefono',
        message: 'Note & domande',
        privacy: privacyUrl => `Sì, acconsento al <a href="${privacyUrl}" target="_blank">trattamento dei miei dati personali</a>.`,
        privacyRequired: 'Acconsentire al trattamento dei dati',
        newsletter: 'Sì, desidero ricevere la newsletter di alto-adige.com',
        newsletterNote: 'La nostra newsletter gratuita sarà inviata regolarmente una volta al mese, con le migliori offerte per vacanze in Alto Adige e utili consigli della redazione. È possibile cancellarsi dal servizio in qualsiasi momento.',
        generalError: 'C’è stato un problema. Si prega di riprovare più tardi.',
        back: 'Indietro',
        submit: count => `Invia la richiesta`,
    },
    thankyou: {
        title: 'Richiesta andata a buon fine',
        successText: 'La richiesta è stata inviata con successo',
    },
};
//# sourceMappingURL=Enquiry.i18n.it.js.map